<div class="not-found">
  <div class="text">
    404 <br />
    Page not found
  </div>
</div>
